import React from "react";
import { Plus, Trash2, RotateCcw, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DEFAULT_INFO_SECTIONS } from "@/pages/cotizador/shared";

/** Textos del cliente · «Information & Documents» al final de la landing (incluye / no incluye / cancelación…). */
export function CuratedTextsTab({ trip, onChange }) {
  const list = trip.info_documents || [];
  const persist = (next) => onChange({ info_documents: next });
  const update = (i, patch) => persist(list.map((s, j) => (j === i ? { ...s, ...patch } : s)));
  return (
    <Card data-testid="curated-texts-tab">
      <CardHeader className="flex-row items-center justify-between space-y-0 pb-3">
        <CardTitle className="flex items-center gap-2 text-base"><FileText className="h-4 w-4 text-primary" /> Information &amp; Documents</CardTitle>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={() => persist(DEFAULT_INFO_SECTIONS.map((s) => ({ ...s })))} data-testid="curated-texts-defaults"><RotateCcw className="mr-1.5 h-3.5 w-3.5" /> Cargar textos estándar</Button>
          <Button size="sm" onClick={() => persist([...list, { title: "Nueva sección", body: "" }])} data-testid="curated-texts-add"><Plus className="mr-1.5 h-3.5 w-3.5" /> Sección</Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        {list.length === 0 && <p className="rounded-md bg-muted px-3 py-2 text-xs text-muted-foreground" data-testid="curated-texts-empty">Sin textos: la landing no mostrará el bloque de información. Carga los textos estándar de Espíritu Travel y adáptalos al grupo.</p>}
        {list.map((s, i) => (
          <div key={i} className="rounded-lg border bg-muted/30 p-3" data-testid={`curated-texts-section-${i}`}>
            <div className="mb-2 flex items-center gap-2">
              <Input value={s.title || ""} onChange={(e) => update(i, { title: e.target.value })} placeholder="Título" className="h-8 flex-1 text-sm font-medium" data-testid={`curated-texts-title-${i}`} />
              <Button size="icon" variant="ghost" className="h-8 w-8 text-destructive" onClick={() => persist(list.filter((_, j) => j !== i))} aria-label="Eliminar" data-testid={`curated-texts-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
            <Textarea rows={5} value={s.body || ""} onChange={(e) => update(i, { body: e.target.value })} className="text-sm" data-testid={`curated-texts-body-${i}`} />
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
